import { render, staticRenderFns } from "./ManagementAdmin.vue?vue&type=template&id=565fac1e&scoped=true"
import script from "./ManagementAdmin.vue?vue&type=script&lang=js"
export * from "./ManagementAdmin.vue?vue&type=script&lang=js"
import style0 from "./ManagementAdmin.vue?vue&type=style&index=0&id=565fac1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565fac1e",
  null
  
)

export default component.exports